import { parse } from 'helpers/dates';

export const buildTransform = typeMap => record => ({
  id: record.id,
  created: parse(`${record.timestamp}Z`),
  inAmount: record.inAmount,
  inCurrency: record.inAsset,
  outAmount: record.outAmount,
  outCurrency: record.outAsset,
  fee: record.feeAmount,
  feeCurrency: record.feeAsset,
  market: 'NBX',
  type: typeMap[record.type],
  notes: record.note
});
